
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./MPCompSuctDrumB.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";





 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function MPCompSuctDrumB() {

        useEffect(() => {
  
    trackPageVisit("MPCompSuctDrumB");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);
    
    
    
const { compressorA, compressorB,  compressorC, compressorD} = useContext(CompressorContext);

const compressor = compressorD; // or A depending on page
    

    const [open, setOpen] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);

    

    
      const historianData = useMemo(() => {
  return {
    time: compressor.history?.time || [],
    PT_suction: compressor.history?.PT_suction || [],
    PT_discharge: compressor.history?.PT_discharge || [],
    TT_suction: compressor.history?.TT_suction || [],
    TT_discharge: compressor.history?.TT_discharge || [],
    FIC_suction: compressor.history?.FIC_suction || [],
    FIC_discharge: compressor.history?.FIC_discharge || [],
    speed: compressor.history?.speed || []
  };
}, [compressor.history]);




  const DEFAULT_VALVES = {
  FCV_18001B: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_18001B: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_18002B: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("MPCompSuctDrumB_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_18001B: { ...DEFAULT_VALVES.FCV_18001B, ...parsed.FCV_18001B },
      PCV_18001B: { ...DEFAULT_VALVES.PCV_18001B, ...parsed.PCV_18001B },
      PCV_18002B: { ...DEFAULT_VALVES.PCV_18002B, ...parsed.PCV_18002B },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("MPCompSuctDrumB_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO MP COMPRESSOR =================

  const [FIC_14004, setFIC_14004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_14004")) || 0;
            setFIC_14004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_14004, setPT_14004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_14004")) || 0;
            setPT_14004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_14004, setTT_14004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_14004")) || 0;
            setTT_14004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


  const [FIC_17003B, setFIC_17003B] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_17003B")) || 0;
            setFIC_17003B(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_17008B, setPT_17008B] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_17008B")) || 0;
            setPT_17008B(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_17008B, setTT_17008B] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_17008B")) || 0;
            setTT_17008B(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



  /* ================= VALVE STATUS ================= */

  const isXV18001BOpen = valves?.XV_18001B === false;
  const isXV18002BOpen = valves?.XV_18002B === false;
  const isXV18003BOpen = valves?.XV_18003B === false;
  const isXV18004BOpen = valves?.XV_18004B === false;
  const isXV18005BOpen = valves?.XV_18005B === false;
  const isXV18006BOpen = valves?.XV_18006B === false;

    const isP18001BOn = pumpData?.["P-18001B"]?.running ?? false;




  const FIC_18009B = FIC_17003B;
  const PT_18005B = PT_17008B;

 const FIC_180011B = isXV18001BOpen ? FIC_14004 : 0;
const PT_18001B = isXV18001BOpen ? PT_14004 : 0.03;

const FIC_18001B =
  PT_18005B > PT_18001B
    ? (FIC_180011B ?? 0) + (FIC_18009B ?? 0)
    : (FIC_180011B ?? 0); 

 const TT_18001B = isXV18001BOpen ? TT_14004 : 22;


const FIC_18004B = isXV18006BOpen ? 30.54 : 0;
const PT_18006B = isXV18006BOpen ? 1.3 : 0.03;
const TT_18004B = isXV18006BOpen ? 24 : 28;


const coolerResults = simulateCooler({

  coolerId: "MP_COOLER_B",

  gasFlow: FIC_18001B,
  gasTempIn: TT_18001B,
  gasPressureIn: PT_18001B,

  waterFlow: FIC_18004B,
  waterTempIn: TT_18004B,
  waterPressureIn: PT_18006B,

  gasValveOpen: isXV18001BOpen,
  waterValveOpen: isXV18006BOpen,

  designEfficiency: 0.84,

  foulingFactor: 0.02
});


const TT_18003B = isXV18001BOpen && !isXV18006BOpen? TT_18001B : (isXV18001BOpen) ? 
  coolerResults.gasTempOut*0.45 : 24;

const PT_18002B = isXV18001BOpen && !isXV18006BOpen? PT_18001B : (isXV18001BOpen) ? 
  coolerResults.gasPressureOut*0.222 : 0.03;

const TT_18002B = isXV18001BOpen && !isXV18006BOpen? TT_18004B : (isXV18001BOpen) ? 
  coolerResults.waterTempOut*1.24 : TT_18004B;


const TT_18005B = TT_18003B * 0.95;

const FIC_18006B = FIC_18001B * 0.78;

const PT_18003B =  isXV18005BOpen ? PT_18002B * ((valveData?.PCV_18001B?.opening || 0)/100) : 0.03;



// ======================================================
// SINGLE STAGE COMPRESSOR SIMULATION
// ======================================================

const compressorResults =
  simulateSingleStageCompressor({

    suctionPressure: PT_18003B,
    suctionTemperature: TT_18005B,
    suctionFlow: FIC_18006B,

    isRunning: compressor.running,

    compressorEfficiency: 0.82,

    compressionRatio: 2.8
  });


useEffect(() => {

  const interval = setInterval(() => {

    updateCompressor(compressor, {
      suctionPressure: PT_18003B,
      suctionTemperature: TT_18005B,
      suctionFlow: FIC_18006B
    });

    forceRender(v => v + 1);

  }, 200); // DCS-like scan time

  return () => clearInterval(interval);

}, [PT_18003B, TT_18005B, FIC_18006B]);

// ======================================================
// DISCHARGE VALUES
// ======================================================

const FIC_18003B =
  compressorResults.dischargeFlow*1.22;

const PT_18008B =
  compressorResults.dischargePressure*20.3;

const TT_18008B =
  compressorResults.dischargeTemperature*1.25;

const PT_18004B = isXV18004BOpen ? 0.3 : 0.03;
const FIC_18008B = isXV18004BOpen ? 1.432 : 0;
const FIC_18007B = compressor.running ? 1.3 + 1.432 : FIC_18008B;

const FIC_18002B = FIC_18003B * 0.3 * (valveData?.PCV_18002B?.opening || 0)/100;

  
  // ================= MP CONDENSATE PUMP (B) =================

const runningPumps18001B = [isP18001BOn].filter(Boolean).length;


// ================= SUCTION INPUTS =================
const suctionFlow18001B = 0;
const suctionPressure18004B = PT_18004B;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_180051B =  1.3 * (valveData?.FCV_18001B?.opening || 0)/100;
const MIN_DISCH_PRESSURE_180051B = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_180051B = MAX_DISCH_PRESSURE_180051B;
let targetFIC_18005B = 0;

if (runningPumps18001B > 0) {

  // 🔹 Flow boost
  targetFIC_18005B = isXV18004BOpen ? 50 * (valveData?.FCV_18001B?.opening || 0)/100 : 0;

  // 🔹 Pressure rises to design max
  targetPT_180051B = isXV18004BOpen ? MIN_DISCH_PRESSURE_180051B* (valveData?.FCV_18001B?.opening || 0)/100 : 0.03;

}

// ================= STATES =================
const [PT_180051B, setPT_180051B] = useState(() => {
  return Number(localStorage.getItem("PT_180051B")) || 0.03;
});

const [FIC_18005B, setFIC_18005B] = useState(() => {
  return Number(localStorage.getItem("FIC_18005B")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_180051B(prev => {
      const next = prev + (targetPT_180051B - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_18005B(prev => {
      const next = prev + (targetFIC_18005B - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_180051B, targetFIC_18005B]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_180051B", PT_180051B);
}, [PT_180051B]);

useEffect(() => {
  localStorage.setItem("FIC_18005B", FIC_18005B);
}, [FIC_18005B]);

useEffect(() => {
  localStorage.setItem("FIC_18003B", FIC_18003B);
}, [FIC_18003B]);

useEffect(() => {
  localStorage.setItem("PT_18008B", PT_18008B);
}, [PT_18008B]);

useEffect(() => {
  localStorage.setItem("TT_18008B", TT_18008B);
}, [TT_18008B]);








  return (
    <div className="MPCompSuctDrumB-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "230px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 200px"
      }}>
        MP COMPRESSOR SUCTION DRUM (B)
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-18001B"
        tag="XV_18001B"
        x={115}
        y={122}
        isClosed={valves.XV_18001B}
        toggle={toggleValve}
      />

      {/* XV-18002B */}
      <Valve
        className="XV-18002B"
        tag="XV_18002B"
        x={878}
        y={186}
        isClosed={valves.XV_18002B}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-18003B */}
      <Valve
        className="XV-18003B"
        tag="XV_18003B"
        x={1025}
        y={186}
        isClosed={valves.XV_18003B}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-18004B */}
      <Valve
        className="XV-18004B"
        tag="XV_18004B"
        x={571}
        y={620}
        isClosed={valves.XV_18004B}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-18005B */}
      <Valve
        className="XV-18005B"
        tag="XV_18005B"
        x={882}
        y={596}
        isClosed={valves.XV_18005B}
        toggle={toggleValve}
        r={270}
      />

      
      {/* XV-18006B */}
      <Valve
        className="XV-18006B"
        tag="XV_18006B"
        x={286}
        y={502}
        isClosed={valves.XV_18006B}
        toggle={toggleValve}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-18001B */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-18001B"
          style={{ position: "absolute", left: 92, top: 722}}  onClick={() => openPanel("FCV_18001B")}>
          
          <defs>
            <linearGradient id="metal_18001B">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,140 20,110"
            fill="url(#metal_18001B)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,140 180,110"
            fill="url(#metal_18001B)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* PCV-18001B */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="PCV-18001B"
          style={{ position: "absolute", left: 855, top: 520, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_18001B")}>
          
          <defs>
            <linearGradient id="metal_18001B">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,140 20,110"
            fill="url(#metal_18001B)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,140 180,110"
            fill="url(#metal_18001B)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* PCV-18002B */}
        <svg width="30" height="30" viewBox="0 0 200 220" className="PCV-18002B"
          style={{ position: "absolute", left: 707, top: 64}}  onClick={() => openPanel("PCV_18002B")}>
          
          <defs>
            <linearGradient id="metal_18002B">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,140 20,110"
            fill="url(#metal_18002B)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,140 180,110"
            fill="url(#metal_18002B)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 140 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 140 + index * 40
              }}
            />
          ))}


          <div
              onClick={() => setOpen(true)}
              style={{
                position: "absolute",
                left: 900,
                top: 350,
                width: 140,
                height: 30,

                background:

                  compressor.status === "RUNNING"
                    ? "#00aa00"

                  : compressor.status === "STARTING"
                    ? "#d4aa00"

                  : compressor.status === "SHUTTING DOWN"
                    ? "#ff8800"

                  : compressor.status === "READY"
                    ? "#0099ff"

                  : compressor.status === "TRIPPED"
                    ? "#ff3300"

                  : "#666666",

                color: "white",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                border: "2px solid cyan",

                cursor: "pointer",

                fontWeight: "bold",

                borderRadius: "8px",

                boxShadow:
                  compressor.running
                    ? "0 0 15px lime"
                    : "0 0 10px red",

                transition: "0.3s"
              }}
            >
              {compressor.status}
            </div>


          {open && (
            <SingleStageCompressorFaceplate
              input={{
                PT_18003B,
                TT_18005B,
                FIC_18006B,
                FIC_18003B,
                PT_18008B,
                TT_18008B,
                isXV18001BOpen,
                isXV18006BOpen
              }}
              compressor={compressor}
              close={() => setOpen(false)}
              openTrend={() => setShowTrend(true)}
            />
          )}




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_18001B?.opening || 0)}
        x={117}
        y={762}
      />
      <ValveOutput
        value={Number(valveData?.PCV_18001B?.opening || 0)}
        x={915}
        y={535}
      />
      <ValveOutput
        value={Number(valveData?.PCV_18002B?.opening || 0)}
        x={707}
        y={90}
      />



          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      <Transmitter
        tag="FIC-18001B"
        value={[FIC_18001B]}
        x={226}
        y={117}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF MP COMPRESSOR"
      />

      <Transmitter
        tag="PT-18001B"
        value={[PT_18001B]}
        x={226}
        y={167}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF MP COMPRESSOR"
      />
      
      <Transmitter
        tag="TT-18001B"
        value={[TT_18001B]}
        x={326}
        y={117}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF MP COMPRESSOR"
      />
      
      <Transmitter
        tag="TT-18004B"
        value={[TT_18004B]}
        x={426}
        y={333}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM FRESH WATER SUPPLY TO MP GAS COOLER (B) FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="PT-18006B"
        value={[PT_18006B]}
        x={426}
        y={373}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM FRESH WATER SUPPLY TO MP GAS COOLER (B) FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="FIC-18004B"
        value={[FIC_18004B]}
        x={146}
        y={493}
        unit="MPM"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM FRESH WATER SUPPLY TO MP GAS COOLER (B) FOR HEAT EXCHANGING WITH GAS"
      />


      <Transmitter
        tag="TT-18003B"
        value={[TT_18003B]}
        x={258}
        y={333}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF COOLED GAS AT THE DISCHARGE OF THE MP GAS COOLER (B) TO MP COMPRESSOR SUCTION DRUM (B)"
      />

      <Transmitter
        tag="PT-18002B"
        value={[PT_18002B]}
        x={676}
        y={269}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF COOLED GAS AT THE DISCHARGE OF THE MP GAS COOLER (B) TO MP COMPRESSOR SUCTION DRUM (B)"
      />

      <Transmitter
        tag="TT-18002B"
        value={[TT_18002B]}
        x={543}
        y={116}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER AT THE DISCHARGE OF THE MP GAS COOLER (B) TO FRESH WATER RETURN LINE"
      />
      <Transmitter
        tag="TT-18005B"
        value={[TT_18005B]}
        x={920}
        y={666}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE SUCTION OF MP COMPRESSOR (B)"
      />

      <Transmitter
        tag="FIC-18006B"
        value={[FIC_18006B]}
        x={826}
        y={666}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE SUCTION OF MP COMPRESSOR (B)"
      />

      <Transmitter
        tag="PT-18003B"
        value={[PT_18003B]}
        x={776}
        y={492}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE SUCTION OF MP COMPRESSOR (B)"
      />
      
      <Transmitter
        tag="FIC-18003B"
        value={[FIC_18003B]}
        x={936}
        y={132}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF MP COMPRESSOR (B)"
      />

      <Transmitter
        tag="PT-18008B"
        value={[PT_18008B]}
        x={1036}
        y={132}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE DISCHARGE OF MP COMPRESSOR (B)"
      />

      <Transmitter
        tag="TT-18008B"
        value={[TT_18008B]}
        x={1124}
        y={132}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE DISCHARGE OF MP COMPRESSOR (B)"
      />

      <Transmitter
        tag="PT-18004B"
        value={[PT_18004B]}
        x={466}
        y={706}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF CRUDE AT THE BOTTOM LEVEL OF MP COMPRESSOR SUCTION DRUM (B) GOING TO MP CONDENSATE PUMP"
      />


      <Transmitter
        tag="FIC-18008B"
        value={[FIC_18008B]}
        x={656}
        y={720}
        unit="MPM"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE BOTTOM LEVEL OF MP COMPRESSOR SUCTION DRUM (B) GOING TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-18005B"
        value={[FIC_18005B]}
        x={226}
        y={667}
        unit="MPM"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE DISCHARGE OF MP CONDENSATE PUMP (B) GOING BACK TO 3RD STAGE SEPARATOR"
      />

      <Transmitter
        tag="PT-180051B"
        value={[PT_180051B]}
        x={226}
        y={680}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF CRUDE AT THE DISCHARGE OF MP CONDENSATE PUMP (B) GOING BACK TO 3RD STAGE SEPARATOR"
      />


      <Transmitter
        tag="FIC-18002B"
        value={[FIC_18002B]}
        x={426}
        y={117}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS RETURNED FROM THE DISCHARGE OF THE MP COMPRESSOR FOR ANTI-SURGE PROTECTION"
      />

      <Transmitter
        tag="FIC-18007B"
        value={[FIC_18007B]}
        x={1106}
        y={720}
        unit="LPM"
        max={10}
        HH={9}
        H={8}
        L={1}
        LL={0.5}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE BOTTOM LEVEL OF MP COMPRESSOR SUCTION DRUM (B) AND COMPRESSOR DURING PURGING AND BLOWDOWN GOING TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-18009B"
        value={[FIC_18009B]}
        x={97}
        y={268}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={10}
        LL={5}
        c="lime"
        description="FLOWRATE OF GAS FROM DISCHARGE OF LP COMPRESSOR SUCTION DRUM (B) AND COMPRESSOR TO INLET OF MP GAS COOLER (B)"
      />

      <Transmitter
        tag="PT-18005B"
        value={[PT_18005B]}
        x={97}
        y={333}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS FROM DISCHARGE OF LP COMPRESSOR SUCTION DRUM (B) AND COMPRESSOR TO INLET OF MP GAS COOLER (B)"
      />










      <Pump
        tag="P-18001B"
        x={375}
        y={749}
        rpm={1800}
        bladeCount={pumpData?.["P-18001B"]?.bladeCount || 5}
        size={pumpData?.["P-18001B"]?.size || 35}
        onClick={openPumpPanel}
      />

      <LevelTransmitterIndicator
      tag="LT-18001B"
      totalLevel={100000}
      inflows={[FIC_18001B * 0.08]}
      outflows={[FIC_18005B]}
      responseFactor={0.05}
      columnX={626}
      columnY={410}
      columnWidth={52}
      columnHeight={147}
      textX={529}
      textY={470}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />





      
           
          {showTrend && (
            <CompressorTrendFaceplate
              data={historianData}
              close={() => setShowTrend(false)}
            />
          )}


    </div>
  );
}


export default MPCompSuctDrumB;

